import { Relationships as RelationshipsType } from "@repo/api/schemas/policiesInventory.schema";
import "./Relationships.css";

import { Box, Typography } from "@saviynt/design-system";
import { memo } from "react";
import { useIntl } from "react-intl";
import { isEmpty } from "../../../util";
import { capitalizeFirstLetter } from "@repo/mfe-core";

interface RelationshipsProps {
  relationships?: RelationshipsType;
}

const RelationshipGroup = memo(
  ({ category, items }: { category: string; items: string[] | null }) => (
    <div className="relationships-body">
      <Typography kind="body3" color="--color-foreground-neutral-subtle">
        {capitalizeFirstLetter(category)}
      </Typography>
      {(items === null || items?.length === 0) && (
        // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        <Typography kind="body2">-</Typography>
      )}
      {(items?.length ?? 0) > 0 &&
        items?.map((item) => (
          <Typography key={`${category}-${item}`} kind="body2">
            {item}
          </Typography>
        ))}
    </div>
  ),
);

export default function Relationships({ relationships }: RelationshipsProps) {
  const intl = useIntl();

  if (!relationships || isEmpty(relationships)) {
    return (
      <Box className="relationships">
        {/* eslint-disable formatjs/no-literal-string-in-jsx  */}
        <Typography kind="body2">-</Typography>
      </Box>
    );
  }

  const relationshipEntries = Object.entries(relationships) as [
    keyof typeof relationships,
    string[],
  ][];

  return (
    <Box className="relationships">
      <Typography kind="h3">
        {intl.formatMessage({
          id: "Iye+m7",
          defaultMessage: "Relationships",
          description:
            "Title for the relationships section in NHI asset sidecar showing connected entities",
        })}
      </Typography>
      {relationshipEntries.length > 0 &&
        relationshipEntries.map(([key, value]) => (
          <RelationshipGroup
            key={key.toString()}
            category={key.toString()}
            items={value}
          />
        ))}
    </Box>
  );
}
